document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.wp-block-acf-video-tab-slider');

  sections.forEach(section => {
    const tabs = section.querySelectorAll('.equipment_tabs__tab');
    const contents = section.querySelectorAll('.slider_wrapper');

    function activateTab(index) {
      tabs.forEach((tab, i) => {
        if (i === index) {
          tab.classList.add('active');
          contents[i].style.display = 'flex';
        } else {
          tab.classList.remove('active');
          contents[i].style.display = 'none';
        }
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateTab(index);
      });
    });

    activateTab(0);
  });
});

document.querySelectorAll('.small-version .accordion').forEach((accordion) => {
  accordion.addEventListener('toggle', function () {
    if (this.open) {
      document.querySelectorAll('.small-version .accordion').forEach((other) => {
        if (other !== this) other.open = false;
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.equipment-details_accordion__section').forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
      if (this.open) {
        document.querySelectorAll('.equipment-details_accordion__section').forEach((other) => {
          if (other !== this) other.open = false;
        });
      }
    });
  });
});
